import "./i18n"; // initialize i18n
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import RFPUpload from "./pages/RFPUpload";
import BidDetail from "./pages/BidDetail";
import VendorPortal from "./pages/VendorPortal";
import VendorQuote from "./pages/VendorQuote";
import RoleSelect from "./pages/RoleSelect";
import BidBond from "./pages/BidBond";
import PaymentSuccess from "./pages/PaymentSuccess";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Library from "./pages/Library";
import SubscriptionGuard from "./components/SubscriptionGuard";
import "./App.css";

function Protected({ children, requireRole, gated = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-text-secondary font-mono-data text-sm" data-testid="loader">
        Initializing Command Center...
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  if (requireRole && user.role !== requireRole && user.role !== "subcontractor") {
    return <Navigate to="/role" replace />;
  }
  return gated ? <SubscriptionGuard>{children}</SubscriptionGuard> : children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
      <Route path="/role" element={<Protected><RoleSelect /></Protected>} />
      <Route path="/dashboard" element={<Protected gated><Dashboard /></Protected>} />
      <Route path="/upload" element={<Protected gated><RFPUpload /></Protected>} />
      <Route path="/bid/:rfpId" element={<Protected gated><BidDetail /></Protected>} />
      <Route path="/vendor" element={<Protected gated><VendorPortal /></Protected>} />
      <Route path="/vendor/quote/:srfqId" element={<Protected gated><VendorQuote /></Protected>} />
      <Route path="/bid-bond" element={<Protected gated><BidBond /></Protected>} />
      <Route path="/library" element={<Protected gated><Library /></Protected>} />
      <Route path="/payment/success" element={<Protected gated><PaymentSuccess /></Protected>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <SubscriptionProvider>
              <AppRouter />
              <Toaster theme="dark" position="top-right" richColors />
            </SubscriptionProvider>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
